
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutdO8nQnR8nzrPUtCMepdGA5olWkwrEA2xJsA81sld4t0Meta } from "/www/wwwroot/FTS/pages/about.vue?macro=true";
import { default as index05DRrO4kuXvQRadv6pkql2jYkQz5GkgKvpD0eKbbIO4Meta } from "/www/wwwroot/FTS/pages/index.vue?macro=true";
import { default as loginOCFnieEnxFtnzlz1bEoQ26owyMTrmLs7rOG394MRnO4Meta } from "/www/wwwroot/FTS/pages/login.vue?macro=true";
import { default as signinaha9Axf5ICYsDyJAncyO1pRg0mYluLWOLeDkG93on4sMeta } from "/www/wwwroot/FTS/pages/signin.vue?macro=true";
import { default as contactuePl2ygm_45SUkLy8ocSLasNcMszATUrcAfUKImT6TRsUMeta } from "/www/wwwroot/FTS/pages/contact.vue?macro=true";
import { default as why_45ftsbw5AQwvxYUFdu_P4ssCYqCsxOmxp_45hIn4SMWOvtpZjEMeta } from "/www/wwwroot/FTS/pages/why-fts.vue?macro=true";
import { default as servicesgwdGTE3h7b4wsn0XOmcieevpPe0sdDG8ws2Uy0wBByYMeta } from "/www/wwwroot/FTS/pages/services.vue?macro=true";
import { default as trackdrive979w6caaFyuEBsyKcoPqBVcyS3ZdyXEydmnNRaE2sx4Meta } from "/www/wwwroot/FTS/pages/trackdrive.vue?macro=true";
import { default as user_45paneldy2yt3q0dD6XrCTN3GYhYcqMWgDFeo0uKPuDCQtZC7cMeta } from "/www/wwwroot/FTS/pages/user-panel.vue?macro=true";
import { default as applicationkFqewePdm9gcIrtQslHEhpHz9bDrc_lIJTExwzbsp5YMeta } from "/www/wwwroot/FTS/pages/application.vue?macro=true";
import { default as indexKuZjgOA6yZ4NfhZcQ8ZdEguUDcRBfgxsSz_BfTEDblIMeta } from "/www/wwwroot/FTS/pages/dashboard/index.vue?macro=true";
import { default as users29wvf5d4A9_45Uu8DYePBII5mKKTUldssoOqImxdx1_BEMeta } from "/www/wwwroot/FTS/pages/dashboard/users.vue?macro=true";
import { default as track_45shipmentsIj0Fb_vG9PHRfAV31kHVbylVkf2QkOkUeEU2dl20_45DoMeta } from "/www/wwwroot/FTS/pages/track-shipments.vue?macro=true";
import { default as messagesziW9FrY0D5htyyZJQu1H_45APD4xL5Dsb_45g60iIFhTs78Meta } from "/www/wwwroot/FTS/pages/dashboard/messages.vue?macro=true";
import { default as settingsL1RwA8pO8BbqMai5KJlN_45EgOrOzTAraoi4BL1qy8zv0Meta } from "/www/wwwroot/FTS/pages/dashboard/settings.vue?macro=true";
import { default as _91id_93x0W6ese7Wi1tYK5oJRMCXQmTHLa21aNtbc5QVcAcE2AMeta } from "/www/wwwroot/FTS/pages/dashboard/pending/[id].vue?macro=true";
import { default as indexwhuLtopsYWIZcu3CPqK_ggQ_45PDnJlNkmaJAMwdVgWywMeta } from "/www/wwwroot/FTS/pages/dashboard/tracks/index.vue?macro=true";
import { default as _91id_939GxBEqI9ZbhleON3ZSDlS1gBxEsB_KyrH851undHzeIMeta } from "/www/wwwroot/FTS/pages/dashboard/employee/[id].vue?macro=true";
import { default as index353yVK9ajKHTityX6EJjrmTDGyINqXyPkjKrLpiEkggMeta } from "/www/wwwroot/FTS/pages/dashboard/pending/index.vue?macro=true";
import { default as indexlLyNXkjo7pxs8Q4thUtc8oic7CvGCspdgTctpwhvaqEMeta } from "/www/wwwroot/FTS/pages/dashboard/employee/index.vue?macro=true";
import { default as _91id_9352uwXi7ufxiDjxRx9UEyaLGSzQN8tKtOC5TNbWTP7OoMeta } from "/www/wwwroot/FTS/pages/dashboard/applications/[id].vue?macro=true";
import { default as teamItewqzuQR_qFiiUPTfxjpCfh5U42nTG_hhCttepxJlAMeta } from "/www/wwwroot/FTS/pages/dashboard/website-data/team.vue?macro=true";
import { default as indexbdbJmYXpknlABIhocILqLvFfFMFGEH7lq95UXqq30vgMeta } from "/www/wwwroot/FTS/pages/dashboard/applications/index.vue?macro=true";
import { default as indexhd1lJBTZcUcm31fLT6C2as1sqU9Jbah_B0k63m4H_KgMeta } from "/www/wwwroot/FTS/pages/dashboard/website-data/index.vue?macro=true";
import { default as mediarLCcpqdtkbq04pzMQ9IQomQlsFtbez0qhIwY7_VmLMAMeta } from "/www/wwwroot/FTS/pages/dashboard/website-data/media.vue?macro=true";
import { default as servicesMnO_dj_45L3rMwJEgXtbl_45QVUT7e8tadMimE_SHuo1_nEMeta } from "/www/wwwroot/FTS/pages/dashboard/website-data/services.vue?macro=true";
import { default as _91id_93yKkUX76aDjo_p6eidneaN3sO1bPZvniyrU63K80lAb8Meta } from "/www/wwwroot/FTS/pages/dashboard/website-data/pages/[id].vue?macro=true";
import { default as indexNuXtGUYDuQHgM6ZCWBdb05HKsu9seJN_454Lb5KGoGIhQMeta } from "/www/wwwroot/FTS/pages/dashboard/website-data/pages/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/www/wwwroot/FTS/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/www/wwwroot/FTS/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginOCFnieEnxFtnzlz1bEoQ26owyMTrmLs7rOG394MRnO4Meta || {}), ...{"middleware":"guest"} },
    component: () => import("/www/wwwroot/FTS/pages/login.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/www/wwwroot/FTS/pages/signin.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/www/wwwroot/FTS/pages/contact.vue")
  },
  {
    name: "why-fts",
    path: "/why-fts",
    component: () => import("/www/wwwroot/FTS/pages/why-fts.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/www/wwwroot/FTS/pages/services.vue")
  },
  {
    name: "trackdrive",
    path: "/trackdrive",
    component: () => import("/www/wwwroot/FTS/pages/trackdrive.vue")
  },
  {
    name: "user-panel",
    path: "/user-panel",
    meta: { ...(user_45paneldy2yt3q0dD6XrCTN3GYhYcqMWgDFeo0uKPuDCQtZC7cMeta || {}), ...{"middleware":["user-only"]} },
    component: () => import("/www/wwwroot/FTS/pages/user-panel.vue")
  },
  {
    name: "application",
    path: "/application",
    component: () => import("/www/wwwroot/FTS/pages/application.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indexKuZjgOA6yZ4NfhZcQ8ZdEguUDcRBfgxsSz_BfTEDblIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-users",
    path: "/dashboard/users",
    meta: { ...(users29wvf5d4A9_45Uu8DYePBII5mKKTUldssoOqImxdx1_BEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/users.vue")
  },
  {
    name: "track-shipments",
    path: "/track-shipments",
    component: () => import("/www/wwwroot/FTS/pages/track-shipments.vue")
  },
  {
    name: "dashboard-messages",
    path: "/dashboard/messages",
    meta: { ...(messagesziW9FrY0D5htyyZJQu1H_45APD4xL5Dsb_45g60iIFhTs78Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/messages.vue")
  },
  {
    name: "dashboard-settings",
    path: "/dashboard/settings",
    meta: { ...(settingsL1RwA8pO8BbqMai5KJlN_45EgOrOzTAraoi4BL1qy8zv0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/settings.vue")
  },
  {
    name: "dashboard-pending-id",
    path: "/dashboard/pending/:id()",
    meta: { ...(_91id_93x0W6ese7Wi1tYK5oJRMCXQmTHLa21aNtbc5QVcAcE2AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/pending/[id].vue")
  },
  {
    name: "dashboard-tracks",
    path: "/dashboard/tracks",
    meta: { ...(indexwhuLtopsYWIZcu3CPqK_ggQ_45PDnJlNkmaJAMwdVgWywMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/tracks/index.vue")
  },
  {
    name: "dashboard-employee-id",
    path: "/dashboard/employee/:id()",
    meta: { ...(_91id_939GxBEqI9ZbhleON3ZSDlS1gBxEsB_KyrH851undHzeIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/employee/[id].vue")
  },
  {
    name: "dashboard-pending",
    path: "/dashboard/pending",
    meta: { ...(index353yVK9ajKHTityX6EJjrmTDGyINqXyPkjKrLpiEkggMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/pending/index.vue")
  },
  {
    name: "dashboard-employee",
    path: "/dashboard/employee",
    meta: { ...(indexlLyNXkjo7pxs8Q4thUtc8oic7CvGCspdgTctpwhvaqEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/employee/index.vue")
  },
  {
    name: "dashboard-applications-id",
    path: "/dashboard/applications/:id()",
    meta: { ...(_91id_9352uwXi7ufxiDjxRx9UEyaLGSzQN8tKtOC5TNbWTP7OoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/applications/[id].vue")
  },
  {
    name: "dashboard-website-data-team",
    path: "/dashboard/website-data/team",
    meta: { ...(teamItewqzuQR_qFiiUPTfxjpCfh5U42nTG_hhCttepxJlAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/website-data/team.vue")
  },
  {
    name: "dashboard-applications",
    path: "/dashboard/applications",
    meta: { ...(indexbdbJmYXpknlABIhocILqLvFfFMFGEH7lq95UXqq30vgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/applications/index.vue")
  },
  {
    name: "dashboard-website-data",
    path: "/dashboard/website-data",
    meta: { ...(indexhd1lJBTZcUcm31fLT6C2as1sqU9Jbah_B0k63m4H_KgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/website-data/index.vue")
  },
  {
    name: "dashboard-website-data-media",
    path: "/dashboard/website-data/media",
    meta: { ...(mediarLCcpqdtkbq04pzMQ9IQomQlsFtbez0qhIwY7_VmLMAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/website-data/media.vue")
  },
  {
    name: "dashboard-website-data-services",
    path: "/dashboard/website-data/services",
    meta: { ...(servicesMnO_dj_45L3rMwJEgXtbl_45QVUT7e8tadMimE_SHuo1_nEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/website-data/services.vue")
  },
  {
    name: "dashboard-website-data-pages-id",
    path: "/dashboard/website-data/pages/:id()",
    meta: { ...(_91id_93yKkUX76aDjo_p6eidneaN3sO1bPZvniyrU63K80lAb8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/website-data/pages/[id].vue")
  },
  {
    name: "dashboard-website-data-pages",
    path: "/dashboard/website-data/pages",
    meta: { ...(indexNuXtGUYDuQHgM6ZCWBdb05HKsu9seJN_454Lb5KGoGIhQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/www/wwwroot/FTS/pages/dashboard/website-data/pages/index.vue")
  }
]